<div class="overlay" *ngIf="visible">
    <div class="cookie-modal">
        <div class="consent-content">
            <div class="title">
                🔒 We Value Your Privacy
            </div>

            EKEDC uses cookies to improve your browsing experience, provide personalized content,
            and analyze site traffic. By clicking “Accept All,” you consent to the use of all cookies and agree to
            <a href="https://webportal.ekedc.com/assets/ToS_Ekedc.pdf">the general conditions of use.</a>

            <div class="actions">
                <button class="btn btn-primary" (click)="acceptAll()">Accept All</button>
                <button class="btn btn-warning" (click)="customize()">Customize</button>
                <button class="btn btn-danger" (click)="rejectAll()">Reject All</button>
            </div>
        </div>

    </div>
</div>
<div class="modal-overlay" *ngIf="showCustomizeModal">
  <div class="customize-modal">

    <h2>Customize Cookie Preferences</h2>
    Choose which types of cookies you consent to:

    <div class="option">
      <label>
        <input type="checkbox" checked disabled />
        <strong>           Necessary Cookies</strong> - Required for site functionality.
      </label>
    </div>

    <div class="option">
      <label>
        <input type="checkbox" />
                  Analytics Cookies - Help us understand site usage.
      </label>
    </div>

    <div class="option">
      <label>
        <input type="checkbox" />
                  Marketing Cookies - Used for personalized offers.
      </label>
    </div>

    <div class="modal-actions">
      <button class="btn btn-primary" (click)="savePreferences()">
        Save Preferences
      </button>
      <button class="btn btn-secondary" (click)="closeCustomize()">
        Cancel
      </button>
    </div>

  </div>
</div>